"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var spacing = ["0rem", // 0
"0.25rem", // 1
"0.5rem", // 2
"1rem", // 3
"1.5rem", // 4
"2rem", // 5
"2.5rem", // 6
"3rem", // 7
"4rem" // 8
];
var _default = spacing;
exports.default = _default;